import { render, staticRenderFns } from "./EmployeeIdentifiersCardsData.vue?vue&type=template&id=03d72564&"
import script from "./EmployeeIdentifiersCardsData.vue?vue&type=script&lang=js&"
export * from "./EmployeeIdentifiersCardsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports